// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__1XLkn","progress":"main_progress__NPIl3"};